import state from './state';
import * as actions from './actions';

const extendedLimitRequests = {
  namespaced: true,
  actions,
  state
};

export default extendedLimitRequests;
